<mat-form-field appearance="outline" class="ui-autocomplete" subscriptSizing="dynamic">
  <mat-label *ngIf="label()">{{ label() }}</mat-label>

  <input
    matInput
    #trigger="matAutocompleteTrigger"
    [matAutocomplete]="auto"
    [formControl]="inputCtrl"
    [required]="required()"
    [attr.aria-disabled]="inputCtrl.disabled"
    [attr.aria-label]="label() || placeholder()"
    [attr.title]="label() || placeholder()"
    [placeholder]="trigger.panelOpen || hasValue() ? placeholder() : ''"
    (input)="onTyping($event)"
    (blur)="onBlur()"
  />

  <mat-autocomplete
    #auto="matAutocomplete"
    class="ui-kit-autocomplete-panel"
    [autoActiveFirstOption]="false"
    (optionSelected)="onOptionSelected($event)"
    (closed)="onPanelClosed()"
  >
    <mat-option
      *ngFor="let opt of filteredOptions()"
      [value]="opt"
      [disabled]="inputCtrl.disabled || isParent(opt)"
      (opened)="onPanelOpened()"
      [ngClass]="{
        'opt-parent': isParent(opt),
        'opt-child': !isParent(opt),
        'has-tag': !!getTag(opt)
      }"
      (mousedown)="onOptionMouseDown()"
    >
      <span class="ui-autocomplete__option-label">{{ getLabel(opt) }}</span>

      <app-chip
        *ngIf="getTag(opt) as tag"
        class="ui-autocomplete__option-chip"
        [text]="tag.text"
        [bgColor]="tag.bgColor ?? ''"
        [textColor]="tag.textColor ?? ''"
      ></app-chip>
    </mat-option>

    <mat-option *ngIf="filteredOptions().length === 0" disabled>
      {{ messageEmpty() }}
    </mat-option>
  </mat-autocomplete>

  <mat-error *ngIf="!inputCtrl.disabled && inputCtrl.invalid && (inputCtrl.dirty || inputCtrl.touched)">
    {{ errorMessage() }}
  </mat-error>
</mat-form-field>